'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

const render = (tagName, { asChild, className, ...rest }, ref) => {
    const Component = asChild ? Slot : tagName;
    return jsx(Component, { className: cl(`ds-list`, className), ref: ref, ...rest });
};
/**
 * ListUnordered component, used to display a list of items.
 * Renders a native `ul` element.
 *
 * @example
 * <ListUnordered>
 *   <ListItem>Item 1</ListItem>
 *   <ListItem>Item 2</ListItem>
 * </ListUnordered>
 */
const ListUnordered = forwardRef(function ListUnordered(props, ref) {
    return render('ul', props, ref);
});
/**
 * ListOrdered component, used to display a list of items.
 * Renders a native `ol` element.
 *
 * @example
 * <ListOrdered>
 *   <ListItem>Item 1</ListItem>
 *   <ListItem>Item 2</ListItem>
 * </ListOrdered>
 */
const ListOrdered = forwardRef(function ListOrdered(props, ref) {
    return render('ol', props, ref);
});

export { ListOrdered, ListUnordered };
